export default "__VITE_ASSET__H5JeFjZ6__"